export const PERMISSIONS = {
    ANALYTICS: 'analytics',
    SCHEDULER: 'scheduler',
    DIRECT_MESSAGES: 'dm',
    ADS: 'ads',
    SCHEDULER_MENTIONS: 'scheduler_mentions'
} as const;
